import { toPascalCase } from "./utils.js";

export function insertCommonParamsToStr(str, model){
    let commonParams = getCommonParams(model);
    for(let key in commonParams){
        let val = commonParams[key];
        str = str.replaceAll(`{${key}}`, val);
    }
    return str;
}

export function getCommonParams(model, getPropsInPascalCase){
    if(typeof getPropsInPascalCase !== 'boolean') getPropsInPascalCase = false;

    let params = {
        'company-name': model.companyName,
        'web-name': model.webName,
        'cdn-path': model.cdnPath,
        'site-key': model.siteKey,
        'theme-color-light': model.themeColorLight,
        'theme-color-dark': model.themeColorDark,
    };

    if(getPropsInPascalCase){
        let newParams = {};
        for(let key in params){
            let val = params[key];
            key = toPascalCase(key);
            key = key.charAt(0).toLowerCase() + key.substring(1);
            newParams[key] = val;
        }
        params = newParams;
    }

    return params;
}